import GlobalErrorModal from '@/components/GlobalErrorModal'
import Header from '@/components/Header'
import Loader from '@/components/Loader'
import NavigationEvents from '@/components/NavigationEvents'
import { usePreventScrollLock } from '@/hooks/usePreventScrollLock.ts'
import { apiClient } from '@/services/PhoenixClientService'
import { getLoggedInUser } from '@/store/auth/thunks/getLoggedInUser.ts'
import { useAppDispatch, useAppSelector } from '@/store/store.ts'
import { HeroUIProvider } from '@heroui/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Suspense, useEffect, useMemo } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { SWRConfig } from 'swr'

import { AppRoutes } from './routes'

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // 5 minutes
			gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
			refetchOnWindowFocus: true, // Disable refetch on window focus
			refetchOnReconnect: true, // Disable refetch on reconnect
			retry: 1, // Retry failed requests once
		},
		mutations: {
			retry: 0, // Don't retry mutations
		},
	},
})

function App() {
	const isLoading = useAppSelector(({ core }) => core.loading)

	const dispatch = useAppDispatch()

	usePreventScrollLock()

	const { pathname } = window.location
	// Check if we're on the auth/callback route (including routes with token parameters)
	const isAuthCallbackRoute = pathname.startsWith(`/auth/callback`)
	// const isLandingRoute = pathname === `/`

	const loading = useMemo(() => {
		if (isAuthCallbackRoute) {
			return false
		}
		return isLoading
	}, [isAuthCallbackRoute, isLoading])

	useEffect(() => {
		if (!isAuthCallbackRoute) {
			dispatch(getLoggedInUser(true))
		}
	}, [dispatch, isAuthCallbackRoute])

	if (loading) {
		return (
			<div className="fixed inset-0 flex items-center justify-center">
				<Loader isLoading={true} text="Loading..." />
			</div>
		)
	}

	return (
		<BrowserRouter>
			{/*<AuthContext.Provider value={{ userRoleLevel: session?.roleLevel || 0, session, setSession, isLoading }}>*/}
			{/*<Provider store={}>*/}
			<QueryClientProvider client={queryClient}>
				<SWRConfig
					value={{
						refreshInterval: 0,
						shouldRetryOnError: false,
						fetcher: apiClient,
					}}
				>
					<HeroUIProvider>
						<Header />
						<div className="wrapper flex flex-col mx-[10px] pb-[10px] xl:mx-[20px] xl:pb-[20px]">
							<Suspense fallback={<Loader isLoading={true} text="Loading..." />}>
								<AppRoutes />
							</Suspense>
						</div>
						<GlobalErrorModal />
						<ToastContainer />
						<NavigationEvents />
					</HeroUIProvider>
				</SWRConfig>
			</QueryClientProvider>
			{/*</Provider>*/}
			{/*</AuthContext.Provider>*/}
		</BrowserRouter>
	)
}

export default App
